import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { useSelector } from 'react-redux';

import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import { getMainAccountId } from 'store/account';
import { Acknowledgment } from 'types/Acknowledgment';

const getAcknowledgments = async (
  mainAccountId: string,
): Promise<Acknowledgment[]> => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/acknowledgments`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.CONDITIONS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        mainAccountId,
      },
    },
  );
  return response?.result ?? [];
};

// keyed on the main account id, which resolves to the impersonated account, so
// a practitioner switching users never reads the previous user's acknowledgments
export const getAcknowledgmentsQuery = (mainAccountId?: string | null) => ({
  queryKey: ['acknowledgments', mainAccountId],
  queryFn: async () =>
    mainAccountId ? await getAcknowledgments(mainAccountId) : [],
});

const useAcknowledgments = () => {
  const mainAccountId = useSelector(getMainAccountId);

  return useSuspenseQuery<Acknowledgment[]>(
    getAcknowledgmentsQuery(mainAccountId),
  );
};

export default useAcknowledgments;
